import ApiEndpointNames from "../../../enums/robot/configuration/api/api-endpoint-names";
import ApiProtocol from "../../../enums/robot/configuration/api/api-protocol";
import ApiTypes from "../../../enums/robot/configuration/api/api-types";

export default interface RobotApiConfig {
  apiEndpointId: ApiEndpointNames;
  apiProtocol: ApiProtocol;
  availableProtocols: ApiProtocol[];
  apiType: ApiTypes;
}

export const getRobotApiConfig = (apiEndpointId: ApiEndpointNames, configs: RobotApiConfig[] | null) => {
  return configs?.find((c) => c.apiEndpointId === apiEndpointId);
};
